import { render, staticRenderFns } from "./TargetManagement.vue?vue&type=template&id=50b5a8e0"
import script from "./TargetManagement.vue?vue&type=script&lang=js"
export * from "./TargetManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports